import React from 'react';
import { Link } from 'react-router-dom';

const RecentPostsWidget = ({ blogPosts }) => {
  const latestPosts = blogPosts.slice().sort((a, b) => new Date(b.publishedDate) - new Date(a.publishedDate)).slice(0, 5);

  return (
    <section className="recent-posts-widget">
      <h3>Recent Posts</h3>
      <ul>
        {latestPosts.map((post) => (
          <li key={post.id}>
            <Link to={post.link}>
              {post.title.substring(0, 50)}...
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default RecentPostsWidget;